import { deprecate } from '@ember/debug';
import { getGlobalConfig } from '@embroider/macros';
function initializeStore(application) {
  application.registerOptionsForType('serializer', {
    singleton: false
  });
  application.registerOptionsForType('adapter', {
    singleton: false
  });
}
function setupContainer(application) {
  initializeStore(application);
}
deprecate('Importing from `ember-data/setup-container` is deprecated without replacement', /* inline-macro-config */getGlobalConfig().WarpDrive.deprecations.DISABLE_6X_DEPRECATIONS, {
  id: 'ember-data:deprecate-legacy-imports',
  for: 'ember-data',
  until: '6.0',
  since: {
    enabled: '5.2',
    available: '4.13'
  }
});
export { setupContainer as default };